import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";


const ExportData = ({ tableData, fileName }) => {
    
    const exportToExcel = (tableData, fileName) => {
        if(tableData && tableData.length > 0){
          const ws = XLSX.utils.json_to_sheet(tableData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
        
          saveAs(data, `${fileName}.xlsx`);
        }else{
          toast.error("No data available")
        }
      };
    
      const exportToPDF = (tableData, fileName) => {
        if(tableData && tableData.length > 0){
          const doc = new jsPDF();
          const tableColumn = Object.keys(tableData[0]); // Get headers
          const tableRows = tableData.map(row => Object.values(row)); // Get values
        
          autoTable(doc, {
              head: [tableColumn],
              body: tableRows,
            });
        
          doc.save(`${fileName}.pdf`);
        }else{
          toast.error("No data available")
        }
      };
    
  return (
    <div className="flex">
      <div onClick={()=>exportToExcel(tableData,fileName)} className="bg-[#fcfcfc] border border-[#ddd] py-[7px] px-[12px] cursor-pointer">
        CSV
      </div>
      <div onClick={()=>exportToPDF(tableData,fileName)} className="bg-[#fcfcfc] border border-[#ddd] py-[7px] px-[12px] cursor-pointer">
        PDF
      </div>
    </div>
  );
};

export default ExportData;
